import { useDomainAccessControl } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'

export const useEnableEnhancedFTC = () => {
  const accessControl = useDomainAccessControl()
  return accessControl([
    { featureToggles: FeatureToggle.EnhancedFulfillmentTestingCenter },
    { warehouseFeatureToggles: FeatureToggle.EnhancedFulfillmentTestingCenter },
  ])
}
